import { DoorFilters } from '@hakimo-ui/hakimo/types';
import { Pagination, Table, TableData } from '@hakimo-ui/hakimo/ui-table';
import { useAppDispatch } from '../store/StateProvider';
import { createUpdatePageAction } from '../store/action-creators';
import { FilterItem } from '../util';
import { DoorListHeader } from './DoorListHeader';

export interface Props {
  selected: string[];
  tableData: TableData;
  loading: boolean;
  fromIndex: number;
  toIndex: number;
  pageSize: number;
  total: number;
  page: number;
  filters: DoorFilters;
  onChangeSelected: (selected: string[]) => void;
  onClickOpenFilter: () => void;
  onClickAddToLocation: () => void;
  onClickAddToDoorGroup: () => void;
  onClickRemoveFromDoorGroup: () => void;
  isDataValid: boolean;
  onSearchFilter: (value: string) => void;
  filterValueType: FilterItem;
  onChangeFilter: (value: FilterItem) => void;
}

export function DoorListTable(props: Props) {
  const {
    selected,
    tableData,
    loading,
    fromIndex,
    toIndex,
    pageSize,
    total,
    page,
    filters,
    onChangeSelected,
    onClickOpenFilter,
    onClickAddToLocation,
    onClickAddToDoorGroup,
    onClickRemoveFromDoorGroup,
    isDataValid,
    onSearchFilter,
    filterValueType,
    onChangeFilter,
  } = props;

  const dispatch = useAppDispatch();

  const tableFooter = (
    <div className="dark:bg-dark-bg border-t bg-white p-4 dark:border-gray-800">
      <Pagination
        from={fromIndex + 1}
        to={toIndex + 1}
        pageSize={pageSize}
        total={total}
        disabled={loading}
        onChangePage={(val) => {
          dispatch(createUpdatePageAction(val));
        }}
      />
    </div>
  );

  return (
    <Table
      data={tableData}
      loading={loading}
      header={
        <DoorListHeader
          selectedDoors={selected}
          filters={filters}
          isLoading={loading}
          onClickFilter={onClickOpenFilter}
          onClickAddToLocation={onClickAddToLocation}
          onClickAddToDoorGroup={onClickAddToDoorGroup}
          onClickRemoveFromDoorGroup={onClickRemoveFromDoorGroup}
          isDataValid={isDataValid}
          onSearchFilter={onSearchFilter}
          filterValueType={filterValueType}
          onChangeFilter={onChangeFilter}
        />
      }
      footer={tableFooter}
      scrollResetKey={page}
      rowSelection={{
        selected,
        onChangeSelected,
      }}
    />
  );
}

export default DoorListTable;
